import uiHeader from '@/pages/components/uiHeader/uiHeader'
import uiFooter from '@/pages/components/uiFooter/uiFooter'

export default {
  name: 'resourceShow',
  data() {
    return {
      imgs: {
        zh: {},
        en: {},
        jp: {}
      },
      lightUp: 0,
      lang: this.$i18n.locale
    }
  },
  components: {
    uiHeader,
    uiFooter
  },
  methods: {
    changeLang(lang){
      this.lang = lang
    },
    changeTab(tab) {
      this.lightUp = tab
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/resourceShow/resourceShow.js